/**
 * cm-coding: Contract Review uploads, review actions, and connector views all
 * show the same workspace document list.
 *
 * Give them one shared React Query key so a connector configuration save
 * refreshes every view instead of leaving one route with stale document names
 * or source metadata.
 */
export const workspaceDocumentsQueryKey = (orgId: string, workspaceId: string) => (
  ['contract-review-documents', orgId, workspaceId] as const
)
